// extracted by mini-css-extract-plugin
export default {"menu":"MainMenu_menu__kYn0u","container":"MainMenu_container__xUBmi"};